
const formatter = new Intl.NumberFormat();
export default (value) => formatter.format(value || 0);
